export default __webpack_public_path__ + "static/media/new-proposal.b51e6390.svg";